export const postManagerOutlet = 'post-manager';
